import {Component} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {NgOptimizedImage} from '@angular/common';
import {MatIcon} from '@angular/material/icon';
import {MatDialogClose, MatDialogContent, MatDialogActions} from '@angular/material/dialog';
import {MatMiniFabButton, MatButton} from '@angular/material/button';


@Component({
    selector: 'myupdates-main-onboarding-dialog',
    templateUrl: './main-onboarding-dialog.component.html',
    styleUrls: ['./main-onboarding-dialog.component.scss'],
    imports: [MatMiniFabButton, MatDialogClose, MatIcon, MatDialogContent, NgOptimizedImage, MatDialogActions, MatButton, TranslatePipe]
})
export class MainOnboardingDialogComponent {
}
